var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLocationPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-location 1",
    clipPath: "url(#clip0_3630_4146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 0.25C3.8 0.25 1.50375 1.997 1.5 4.5C1.4955 7.49525 6 12 6 12C6 12 10.5048 7.5015 10.5 4.5C10.496 2.00075 8.2 0.25 6 0.25ZM6 6.5C4.8955 6.5 4 5.6045 4 4.5C4 3.3955 4.8955 2.5 6 2.5C7.1045 2.5 8 3.3955 8 4.5C8 5.6045 7.1045 6.5 6 6.5Z",
    fill: "#735BF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3630_4146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationPrimary);
export default __webpack_public_path__ + "static/media/iconLocationPrimary.ad59690e3574853fcc9c70a95bc10d00.svg";
export { ForwardRef as ReactComponent };